import { useLocation, Outlet } from "react-router-dom";
import {
  Plane, MapPin, Building2, UserCheck, Landmark, ShieldAlert, Settings
} from "lucide-react";
import HubSidebar from "@/components/HubSidebar";


import TopNav from "@/components/TopNav"
import HubSwitcher from "@/components/HubSwitcher";
const NAV_ITEMS = [
  {
    id: "my-trips",
    label: "My Trips",
    icon: MapPin,
    path: "/travelling/my-trips",
    description: "Your trip requests & claims",
  },
  {
    id: "travel-desk",
    label: "Travel Desk",
    icon: Building2,
    path: "/travelling/travel-desk",
    description: "Booking & accommodation",
  },
  {
    id: "manager",
    label: "Manager",
    icon: UserCheck,
    path: "/travelling/manager",
    description: "Recommend claims & reconciliations",
  },
  {
    id: "finance",
    label: "Finance",
    icon: Landmark,
    path: "/travelling/finance",
    description: "Approve & disburse",
  },
  {
    id: "suspicious",
    label: "Suspicious",
    icon: ShieldAlert,
    path: "/travelling/suspicious",
    description: "Suspicious receipts repository",
  },
  {
    id: "currency",
    label: "Currency",
    icon: Settings,
    path: "/travelling/currency",
    description: "S&T rates & currency admin",
  },
];

export default function TravellingAdminLayout() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
    <TopNav />
    <div className="min-h-screen bg-app flex flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS}
        title="TRAVELLING ADMIN"
        subtitle="Trip Management"
        icon={Plane}
        gradient="from-sky-500 to-blue-600"
        activeBg="bg-sky-500"
      />

      <main className="flex-1 overflow-auto flex">
        <div className="flex-1 min-w-0 p-4">
          <Outlet />
        </div>
        <div className="hidden lg:block w-40 shrink-0 p-3 border-l border-app">
          <HubSwitcher />
        </div>
      </main>
    </div>
    </>
  );
}
